module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVHgB1ZVbCoAgEEW1jRT0lVDUSqvFaQtwBbaBSQV/fYyKdmD+LveAqENBQyoykMr0K3iEsBMEEAjOYV83OPRIKb3ZZIErn8cJ7vMK5pMEqeVJAkx5tABbHiXIKQ8Kcsu9ghLlhuovud0RlZK0v6a5kn6+Cqwk67s28yrlzVJrQeCWzcKYN4cWxPL/pf8BcYhKjGg0Sl4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/back_arrow_mobile.png
// module id = 1763
// module chunks = 0